import { getOrderFulfillmentCTA } from "./shared";
export var AddOrUpdate = function AddOrUpdate(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return addOrUpdateBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return addOrUpdateBuilder(strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getOrderFulfillmentC;
        return (_getOrderFulfillmentC = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC === void 0 ? void 0 : _getOrderFulfillmentC.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getOrderFulfillmentC2, _getOrderFulfillmentC3;
        return (_getOrderFulfillmentC2 = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC2 === void 0 ? void 0 : (_getOrderFulfillmentC3 = _getOrderFulfillmentC2.getLink) === null || _getOrderFulfillmentC3 === void 0 ? void 0 : _getOrderFulfillmentC3.call(_getOrderFulfillmentC2);
      }
    }
  };
};
var addOrUpdateBuilder = function addOrUpdateBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "qfCs6w",
        defaultMessage: [{
          "type": 0,
          "value": "Adicionar informações de seguimento ao enviar por conta própria"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "UbgtZ8",
        defaultMessage: [{
          "type": 0,
          "value": "Pode adicionar ou atualizar informações de seguimento no \"Passo 4. Informações de envio\" da página de processamento da encomenda. Consulte os artigos do Centro de Ajuda que encontrámos abaixo para obter instruções mais detalhadas."
        }]
      })];
    }
  };
};